import { Checkbox } from "antd";
import { type StrictlyFrozenSet, setIntersection, toReadonlySet } from "utils/sets";
import type { FrozenSetDispatch } from "utils/useFrozenState";

const noIds = toReadonlySet<string>([]);

interface HeaderSelectionCheckboxProps {
    readonly selectedRows: StrictlyFrozenSet<string>;
    readonly setSelectedRows: FrozenSetDispatch<string>;
    readonly selectableSet: StrictlyFrozenSet<string>;
    readonly disabled?: boolean;
}

export const HeaderSelectionCheckbox = ({
    selectedRows,
    setSelectedRows,
    selectableSet,
    disabled,
}: HeaderSelectionCheckboxProps) => {
    const intersection = setIntersection(selectedRows, selectableSet);
    const selectedAll = intersection.size >= selectableSet.size;
    const selectedSome = intersection.size > 0 && !selectedAll;

    return (
        <Checkbox
            aria-label="Select all rows"
            disabled={disabled}
            checked={selectedAll}
            indeterminate={selectedSome}
            onChange={(e) => {
                const checked = e.target.checked;
                if (checked) {
                    // select-all
                    setSelectedRows(selectableSet);
                } else {
                    // select-none
                    setSelectedRows(noIds);
                }
            }}
        />
    );
};
